module.exports = __webpack_public_path__ + "static/media/logout.b70eb2f3.svg";